/**
 * @param {OnlineTask} task
 * @param {UserService} userService
 * @param tradingSessionResource
 *
 * @returns {Promise}
 */
const saveTradingSessionEntryTaskHandler = (task, userService, tradingSessionResource) => {
    const data = task.data;
    task.data.onlineTaskTrigger = task.onlineTaskTrigger;

    // TODO: Having device api keys would be much nicer here.
    let apiKey = task.apiKey;
    if (!apiKey) {
        // If there's no API key on the task use the current logged in user's.
        apiKey = userService.getApiKey();
    }

    if (!apiKey) {
        // If there's still no API key don't sent the request because we know it will fail.
        console.warn('TradingSessionEvent has no apiKey. Not sending to API.', task);
        return Promise.reject();
    }

    // Remove any apiKey from the POST data - it should only be sent in the GET data.
    // The task may have an apiKey on it that failed (above) and we're retrying with the current user's apiKey.
    // That causes a mismatch on the API because it will accept a POSTed apiKey and that would take priority
    // over the one in the query string.
    // In reality there should no longer be an apiKey in the task's data, but before PRO-1416 apiKeys were stored in
    // in the data of a trading session event, so this is to prevent that.
    delete data.apiKey;

    return new Promise((resolve, reject) => {
        tradingSessionResource.saveEvent(
            {
                apiKey,
                onlineTaskTrigger: data.onlineTaskTrigger,
            },
            data,
            resolve,
            reject
        );
    });
};

module.exports = saveTradingSessionEntryTaskHandler;
